var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.77 22.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#528918;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,17.25c.12-.51.48-.75.45-1.41a15.52,15.52,0,0,0,.93-3.6.66.66,0,0,1,.39-.36A17.74,17.74,0,0,0,1.2,5.19c0-.45.21-.6.09-.75-.06-.36.36-.27.66-.27A8.07,8.07,0,0,0,1.38,2C1.71,1.23,1.71.54,2,0,4.56.78,6.87,2.16,9.09,2.7c3.39,2.43,7.41,4.44,7.68,9.45a3.26,3.26,0,0,0-.18,1.2c-2.76,4.89-9,6.36-14.19,8.82C.18,21.57.21,19.47,0,17.25ZM4.92,5.64a20.17,20.17,0,0,1,.18,9.93c1-.06,1.47-.75,2.7-.84.12-.27.45-.42.63-.63,2-.78,3.9-1.59,4.74-3.54C12.57,9.42,11.22,9,10.65,7.8,9.42,7.59,8.94,6.66,7.59,6.57c0-.12-.12-.12-.09-.27a5.33,5.33,0,0,1-2.22-.75A.64.64,0,0,0,4.92,5.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDGreen);
export default __webpack_public_path__ + "static/media/d-green.681c920f774934e35df5873ced184036.svg";
export { ForwardRef as ReactComponent };